module.exports = __webpack_public_path__ + "static/media/list-plus.f61c0731.svg";